//import React, { Component } from "react";
import React, { FC, useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    container: {
        width: 800,
        marginLeft: 'auto',
        marginRight: 'auto',
        fontSize: 24
    },

    siteTitle: {
        fontSize: 100,
        textAlign: 'center'
    },

    navBar: {
        alignSelf: 'center'

    }
}));

const Home = () => {
    const classes = useStyles();

    useEffect(() => {
    }, []);

    return (
        <div className={classes.container}>
            <h1>What is THRONEZ?</h1>
            <ol>
                <li>
                    <strong>Referral-based NFT</strong>
                    <p>In order to participate, you need to get the token from the token holder or NFT store like OpenSea.</p>
                    <p>Token holder can mint 10 new tokens for free from you own.</p>
                </li>
                <li>
                    <strong>Creating Communities</strong>
                    <p>THRONEZ is the new form of the community.</p>
                    <p>On Polygon Blockchain, Each Token Records ... </p>
                    <ul>
                        <li><p>The Boss introduced you </p></li>
                        <li><p>A Position like King, Prince, Duke and so on. The tokens generated will be one position below the original token.</p></li>
                        <li><p>A Name that is displayed in SVG format. (It can be changed with 10 MATIC.)</p></li>
                    </ul>
                    <p>Can Recruit by giving the generated token to someone else, and the power of the original token will increase.</p>
                </li>
                <li>
                    <strong>Reward</strong>
                    <p>The most powerful token are promoted to God position.</p>
                    <p>God Token holder get the right to get 80% of the MATIC saved in the contract. (20% goes to project management.)</p>
                </li>
            </ol>
        </div>
    );
    //}
}

export default Home;
